/* tslint:disable:max-line-length */
import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  instructions: {
    defaultMessage: 'To log in, scan this QR code with the BankID app.',
    id: 'BankIdAuthWithSupplementalContainer.instructions',
  },
  paymentInstructions: {
    defaultMessage: 'To sign your payment, scan this QR code with the BankID app.',
    id: 'BankIdAuthWithSupplementalContainer.paymentInstructions',
  },
  bankIdInstructions: {
    defaultMessage: 'To continue, scan the QR code with your <b>BankID app</b>.',
    id: 'BankIdAuthWithSupplementalContainer.bankIdInstructions',
  },
});
